export const myHelper = Object.assign(
    {
        translateRole(role) {
            switch (role) {
                case 'admin': return 'administrador';
                case 'user': return 'usuário';
                case 'former': return 'formador';
                case 'fisher': return 'pescador';
                case 'rower': return 'remador';
            }
        }
    }
)